import React, { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

function SleeveSendSuccess({
  Lang,
  onViewEnvelope,
  onEnvelopeStart
}) {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { link, otp, recipient, sender, due_date } = location.state || {};

  const handleCopyLink = (e) => {
    e.preventDefault();
    if (link) {
      const formattedData = `
Dear ${recipient?.name || ''},
I hope you are doing well.

Please upload the required documents by visiting the following link:
🔗 ${link}

You will need to enter the following access code to proceed:
🔐 Access Code: ${otp || ''}

Kindly complete this request before ${due_date || ''}
If you have any questions or face any issues, feel free to reach out.

Best regards,
${sender?.name || ''}
${sender?.company || ''}
📞 ${sender?.mobile_number || ''}
📧 ${sender?.email || ''}
      `.trim();
      navigator.clipboard.writeText(formattedData)
        .then(() => {
          toast.success("Link copied to clipboard!");
        })
        .catch((err) => {
          toast.error("Failed to copy link.");
        });
    } else {
      toast.error("No link available to copy.");
    }
  };

  // Prevent back navigation to previous steps
  useEffect(() => {
    const handlePopState = () => {
      navigate('/client-portal/sleeve', { replace: true });
    };
    window.addEventListener('popstate', handlePopState);

    // Fallback: If user lands directly or history is too short, redirect to step 1
    if (window.history.length <= 2) {
      navigate('/client-portal/sleeve', { replace: true });
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  // Provide default handlers if not passed as props
  const handleViewEnvelope = onViewEnvelope || (() => navigate(`/manage/${uuid}`));
  const handleEnvelopeStart = onEnvelopeStart || (() => navigate("/client-portal/sleeve/create"));

  return (
    <div className="sleeve-gradient-bg-step mt-0 section-bg-color" style={{minHeight: 'calc(100vh - 54.5px)'}}>
      <div className="container mt-4">
        <div className="sleeve-success-card card shadow-lg rounded-lg p-4 d-flex flex-column align-items-center">
          <div className="sleeve-success-icon d-flex justify-content-center align-items-center mb-3">
            <i className="bi bi-check2-circle"></i>
          </div>
          <h2 className="sleeve-success-title fw-bold text-center">Your Sleeve has been Successfully Sent!</h2>
          {link && recipient && (recipient.name || recipient.email) && (
            <div className="text-center my-3">
              <button
                type="button"
                className="btn btn-outline-primary btn-md"
                onClick={handleCopyLink}
                data-toggle="tooltip"
                title="Copy the link to clipboard"
              >
                <i className="bi bi-clipboard me-2"></i> Copy Link
              </button>
            </div>
          )}
          <div className=" sleeve-action-btn-group">
            <button
              className="sleeve-action-btn sleeve-action-btn-outline fw-semibold d-flex align-items-center justify-content-center"
              data-bs-toggle="tooltip"
              title={Lang?.env_view_envelope || "View Sleeve"}
              onClick={handleViewEnvelope}
            >
              <i className="bi bi-eye me-2"></i> View Sleeve
            </button>
            <button
              className="sleeve-action-btn sleeve-action-btn-dark fw-semibold d-flex align-items-center justify-content-center"
              data-bs-toggle="tooltip"
              title={Lang?.env_create_another || "Create New"}
              onClick={handleEnvelopeStart}
            >
              <i className="bi bi-plus-circle me-2"></i> Create New
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SleeveSendSuccess; 